<script setup lang="ts">
import { getEnvVar } from '@/utils/env';
import { getCurrentLocale } from '@/i18n';

const lang = getCurrentLocale();
const cdnBaseUrl = getEnvVar('VITE_VACV_COMMON_STATIC_URL');
</script>

<template>
  <div class="acv-logo-cntr card">
    <div>
      <h1 class="h4style">{{ $t('common.empty_title') }}</h1>
      <p>{{ $t('common.empty_des') }}</p>
    </div>
    <div class="acv-logo">
      <img :src="`${cdnBaseUrl}/img/acv-logo_${lang}.svg`" :alt="$t('common.acv-logo')" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.acv-logo-cntr {
  display: flex;
}
.acv-logo {
  order: 2;
  margin-left: auto;
  img {
    height: 40px;
    width: 300px;
  }
}
</style>
